import { render, staticRenderFns } from "./editorOperation.vue?vue&type=template&id=2b1c652a&scoped=true&"
import script from "./editorOperation.vue?vue&type=script&lang=js&"
export * from "./editorOperation.vue?vue&type=script&lang=js&"
import style0 from "./editorOperation.vue?vue&type=style&index=0&id=2b1c652a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c652a",
  null
  
)

export default component.exports